(function () {
  if (!/\/pages\/make-an-enquiry(\/|$|\?)/.test(window.location.pathname + window.location.search)) {
    return;
  }

  var bodyLabel = document.querySelector('label[for="ContactForm-body"]');
  var body = document.querySelector('#ContactForm-body');
  if (bodyLabel) bodyLabel.textContent = 'Additional message';
  if (body) body.setAttribute('placeholder', 'Additional message');

  var form = document.querySelector('#ContactForm');
  if (!form) return;

  var contactFields = form.querySelector('.contact__fields');
  if (contactFields) {
    var yourDetailsHeading = document.createElement('h3');
    yourDetailsHeading.className = 'enquire-section-heading';
    yourDetailsHeading.textContent = 'Your details';
    contactFields.parentNode.insertBefore(yourDetailsHeading, contactFields);
  }

  var params = new URLSearchParams(window.location.search);
  var product = params.get('product');
  var productUrl = params.get('product_url') || '';
  var optionsRaw = params.get('options') || '';

  if (!product && !optionsRaw) return;

  var optionPairs = optionsRaw
    .split('|')
    .map(function (pair) {
      var idx = pair.indexOf(':');
      if (idx === -1) return null;
      return [pair.slice(0, idx).trim(), pair.slice(idx + 1).trim()];
    })
    .filter(function (pair) {
      return pair && pair[0] && pair[1];
    });

  var productHeading = document.createElement('h3');
  productHeading.className = 'enquire-section-heading';
  productHeading.textContent = 'Product details';

  var details = document.createElement('div');
  details.className = 'enquire-details';

  var dl = document.createElement('dl');
  dl.className = 'enquire-details__list';

  function addRow(label, value) {
    if (!value) return;
    var dt = document.createElement('dt');
    dt.className = 'enquire-details__label';
    dt.textContent = label;
    var dd = document.createElement('dd');
    dd.className = 'enquire-details__value';
    dd.textContent = value;
    dl.appendChild(dt);
    dl.appendChild(dd);
  }

  if (product) addRow('Product', product);
  if (optionPairs.length) {
    addRow(
      'Selections',
      optionPairs
        .map(function (p) {
          return p[0] + ': ' + p[1];
        })
        .join(' · ')
    );
  }

  details.appendChild(dl);
  form.insertBefore(details, form.firstChild);
  form.insertBefore(productHeading, details);

  function addHidden(name, value) {
    if (!value) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'contact[' + name + ']';
    input.value = value;
    form.appendChild(input);
  }

  if (product) addHidden('Product', product);
  if (productUrl) {
    var fullUrl = /^https?:\/\//i.test(productUrl)
      ? productUrl
      : window.location.origin + productUrl;
    addHidden('Product URL', fullUrl);
  }
  if (optionPairs.length) {
    addHidden(
      'Selections',
      optionPairs
        .map(function (p) {
          return p[0] + ': ' + p[1];
        })
        .join(' | ')
    );
  }
})();
